/* tslint:disable */
/* eslint-disable */
/**
 * Wolf Security Portal Customer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0 (2.0)
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Country } from './Country';
import {
    CountryFromJSON,
    CountryFromJSONTyped,
    CountryToJSON,
} from './Country';

/**
 * 
 * @export
 * @interface TenantSearch
 */
export interface TenantSearch {
    /**
     * 
     * @type {string}
     * @memberof TenantSearch
     */
    readonly id: string;
    /**
     * 
     * @type {string}
     * @memberof TenantSearch
     */
    readonly shortId: string;
    /**
     * 
     * @type {string}
     * @memberof TenantSearch
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof TenantSearch
     */
    readonly canActivateLicenses: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TenantSearch
     */
    readonly eligibleForTrial: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TenantSearch
     */
    readonly canActivateTrialLicenses: boolean;
    /**
     * 
     * @type {string}
     * @memberof TenantSearch
     */
    readonly partnerId: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TenantSearch
     */
    isBusiness?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof TenantSearch
     */
    companyName?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantSearch
     */
    addressLine1?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantSearch
     */
    addressLine2?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantSearch
     */
    addressCity?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantSearch
     */
    addressCounty?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantSearch
     */
    addressPostCode?: string;
    /**
     * 
     * @type {Country}
     * @memberof TenantSearch
     */
    addressCountry?: Country | null;
    /**
     * 
     * @type {string}
     * @memberof TenantSearch
     */
    contactName?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantSearch
     */
    contactEmail?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantSearch
     */
    readonly editionId: string;
}

/**
 * Check if a given object implements the TenantSearch interface.
 */
export function instanceOfTenantSearch(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "shortId" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "canActivateLicenses" in value;
    isInstance = isInstance && "eligibleForTrial" in value;
    isInstance = isInstance && "canActivateTrialLicenses" in value;
    isInstance = isInstance && "partnerId" in value;
    isInstance = isInstance && "editionId" in value;

    return isInstance;
}

export function TenantSearchFromJSON(json: any): TenantSearch {
    return TenantSearchFromJSONTyped(json, false);
}

export function TenantSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): TenantSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'shortId': json['short_id'],
        'name': json['name'],
        'canActivateLicenses': json['can_activate_licenses'],
        'eligibleForTrial': json['eligible_for_trial'],
        'canActivateTrialLicenses': json['can_activate_trial_licenses'],
        'partnerId': json['partner_id'],
        'isBusiness': !exists(json, 'is_business') ? undefined : json['is_business'],
        'companyName': !exists(json, 'company_name') ? undefined : json['company_name'],
        'addressLine1': !exists(json, 'address_line_1') ? undefined : json['address_line_1'],
        'addressLine2': !exists(json, 'address_line_2') ? undefined : json['address_line_2'],
        'addressCity': !exists(json, 'address_city') ? undefined : json['address_city'],
        'addressCounty': !exists(json, 'address_county') ? undefined : json['address_county'],
        'addressPostCode': !exists(json, 'address_post_code') ? undefined : json['address_post_code'],
        'addressCountry': !exists(json, 'address_country') ? undefined : CountryFromJSON(json['address_country']),
        'contactName': !exists(json, 'contact_name') ? undefined : json['contact_name'],
        'contactEmail': !exists(json, 'contact_email') ? undefined : json['contact_email'],
        'editionId': json['edition_id'],
    };
}

export function TenantSearchToJSON(value?: TenantSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'is_business': value.isBusiness,
        'company_name': value.companyName,
        'address_line_1': value.addressLine1,
        'address_line_2': value.addressLine2,
        'address_city': value.addressCity,
        'address_county': value.addressCounty,
        'address_post_code': value.addressPostCode,
        'address_country': CountryToJSON(value.addressCountry),
        'contact_name': value.contactName,
        'contact_email': value.contactEmail,
    };
}

